<div [ngStyle]="message.state ? {'background':'green'} : { 'background':'red'}" class="message-view" *ngIf="message">
    <span class="message-view__text">{{message.message | translate: message.params}}</span>

    <ng-container *ngIf="gs.bShowOverbookingErrorDialog">
        <div class="overlap-booking-error-action-container">           
            <app-button [buttontype]="secondaryButton" (valueChange)="closeMessage()"></app-button>
            <app-button [buttontype]="primaryButton" (valueChange)="emitOverlapBookingproceedEvent()"></app-button>
        </div>        
    </ng-container>
    
    <span *ngIf="!gs.bShowOverbookingErrorDialog" class="message-view__close icon-close" (click)="closeMessage()"></span>
</div>